
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BCLC',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/BCLC.vue